import { ComboboxData, ComboboxItem, ComboboxItemGroup } from "@mantine/core"
import { useCallback } from "react"

type SortSelectOptionsProps = {
  sort?:
    | ((
        a: string | ComboboxItem | ComboboxItemGroup,
        b: string | ComboboxItem | ComboboxItemGroup
      ) => number)
    | false
}

export const useSortSelectOptions = ({ sort }: SortSelectOptionsProps) => {
  return useCallback(
    (data: ComboboxData | undefined): ComboboxData | undefined => {
      if (sort === false || !Array.isArray(data)) {
        return data
      }

      if (typeof sort === "function") {
        return data.sort(sort)
      }

      // default sort: when props.sort is not provided (undefined)
      return data.sort((a, b) => {
        if (typeof a === "string" && typeof b === "string") {
          return a.localeCompare(b)
        }
        if (typeof a === "object" && typeof b === "object") {
          if ("label" in a && "label" in b) {
            return a.label.localeCompare(b.label)
          }
          if ("group" in a && "group" in b) {
            return a.group.localeCompare(b.group)
          }
          return 0
        }
        return 0
      })
    },
    [sort]
  )
}
